module.exports = __webpack_public_path__ + "img/sidebar-narrow-fsc-icon.e2a84648.png";